import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const AppNavigation = () => import(/* webpackChunkName: "4-feat-appnavigation-phase1" */ './AppNavigation');

export default lazyLoadOnRender({ loader: AppNavigation });
